import { Backdrop, Box, CircularProgress } from "@mui/material";

function ApiLoader() {
  return (
    <>
      <Backdrop open sx={{ zIndex: 9999, backgroundColor: "#10111e73" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      </Backdrop>
    </>
  );
}
export default ApiLoader;
